import { createGeneralSelectors } from '../_common/selectors';

const getPhraseCpsrChapterSlice = state => state.phraseCpsrChapter;

export const { getById, getIds, getLoading, getByQueryIds, makeGetByQuery, makeGetByQueryLoading } = createGeneralSelectors(
  getPhraseCpsrChapterSlice,
);
